import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbsDown = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 9C15.5 6.51472 13.4853 5 11 5H10.162C7.8365 5 6.67375 5 5.82311 5.75085C4.97246 6.5017 4.84449 7.52445 4.58856 9.56996C4.53363 10.009 4.5 10.4147 4.5 10.75C4.5 12.5784 5.17157 13 7 13H11C13.4853 13 15.5 11.4853 15.5 9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8 11.6L13.1656 12.5307C13.6129 12.3551 13.8719 11.8861 13.7825 11.4139C13.6931 10.9418 13.2805 10.6 12.8 10.6V11.6ZM8.5 16H7.5C7.5 16.4847 7.84768 16.8997 8.32496 16.9845C8.80223 17.0694 9.27163 16.7997 9.43872 16.3447L8.5 16ZM9.5 16C9.5 15.3915 9.66879 14.5094 10.1573 13.8102C10.6073 13.166 11.376 12.6 12.8 12.6V10.6C10.724 10.6 9.3427 11.4839 8.51774 12.6648C7.73121 13.7906 7.5 15.1085 7.5 16H9.5ZM8.5 16C9.43872 16.3447 9.4386 16.345 9.43848 16.3453C9.43845 16.3454 9.43833 16.3457 9.43827 16.3459C9.43813 16.3462 9.43802 16.3466 9.43792 16.3468C9.43772 16.3474 9.43759 16.3477 9.43753 16.3479C9.4374 16.3482 9.43755 16.3478 9.43798 16.3467C9.43883 16.3445 9.44079 16.3393 9.44388 16.3315C9.45006 16.3159 9.46073 16.2895 9.47608 16.2534C9.50682 16.1813 9.55607 16.0712 9.62525 15.9328C9.76407 15.6551 9.98042 15.2686 10.2845 14.8473C10.8968 13.9992 11.8319 13.0546 13.1656 12.5307L12.4344 10.6692C10.6313 11.3775 9.41641 12.6329 8.66289 13.6767C8.28407 14.2015 8.01358 14.6839 7.83627 15.0387C7.74739 15.2165 7.68126 15.3635 7.63613 15.4695C7.61355 15.5225 7.59617 15.5653 7.58378 15.5967C7.57758 15.6124 7.57263 15.6252 7.56889 15.635C7.56702 15.6399 7.56545 15.6441 7.56418 15.6475C7.56355 15.6492 7.56299 15.6507 7.56251 15.652C7.56227 15.6526 7.56204 15.6532 7.56184 15.6538C7.56174 15.6541 7.5616 15.6544 7.56155 15.6546C7.56141 15.6549 7.56128 15.6553 8.5 16Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgThumbsDown);
export { ForwardRef as ReactComponent };
